<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconColumns_32"
    viewBox="0 0 32 32"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M2 23.693V8.115a3 3 0 0 1 .915-2.2A3 3 0 0 1 5.115 5h21.77a3 3 0 0 1 2.2.915 3 3 0 0 1 .915 2.2v15.578a3 3 0 0 1-.915 2.2 3 3 0 0 1-2.2.915H5.115a3 3 0 0 1-2.2-.915 3 3 0 0 1-.915-2.2m3.076 0h5.18V8.115h-5.18zm8.295 0h5.18V8.115h-5.18zm8.295 0h5.18V8.115h-5.18z"
    />
</svg>
